import { connect } from 'react-redux'

import PositionsTable from '../components/PositionsTable'
import { RootState } from '../types'
import { TradingAction, selectPosition, closeAllTrades } from '../actions'
import { closeTrade } from '../actions/TradeActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { setChartMode } from '../actions/commonActions'
import { updateFavourites } from '../actions/GraphQLActions'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    currency: state.currency,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    assets: mt4.assets,
    positions: Array.from(mt4.positions.values()),
    accountLoaded: state.accountLoaded,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    selectedPosition: state.selectedPosition,
    favourites: rootState.favourites,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onCloseAllTrades: () =>
      dispatch(
        setModal(I18n.t(`closingPositions`), I18n.t('closeAllPositionsMessage'), closeAllTrades())
      ),
    onCloseTrade: (order: number, uuid?: string) =>
      dispatch(
        setModal(I18n.t(`closingPosition`), I18n.t('closePositionMessage'), closeTrade(order, uuid))
      ),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
    onSetChartMode: () => dispatch(setChartMode('open')),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionsTable)
